(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uni-purchase-summary"] && !Shopify.designMode) return;
  try {
    (() => {
  function syncPurchaseSummary(product) {
    if (!product) return;
    const summary = product.querySelector('[data-uni-purchase-summary]');
    const select = product.querySelector('[data-uni-product-form] [name="id"]');
    const source = product.querySelector('[data-uni-product-json]');
    if (!summary || !select || !source) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch { return; }
    const variant = data.variants?.find(item => String(item.id) === String(select.value));
    if (!variant) return;
    const kind = ['single', 'bundle', 'partial'].includes(variant.kind) ? variant.kind : 'single';
    summary.querySelector('[data-uni-summary-title]').textContent = variant.title === 'Default Title' ? data.title : variant.title;
    summary.querySelector('[data-uni-summary-money]').textContent = variant.money;
    summary.querySelector('[data-uni-summary-kind]').textContent = summary.getAttribute('data-kind-' + kind);
  }
  function syncAllPurchaseSummaries() {
    document.querySelectorAll('[data-uni-product]').forEach(syncPurchaseSummary);
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-uni-product-form] [name="id"]')) syncPurchaseSummary(event.target.closest('[data-uni-product]'));
  });
  document.addEventListener('shopify:section:load', syncAllPurchaseSummaries);
  window.addEventListener('pageshow', syncAllPurchaseSummaries);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAllPurchaseSummaries, {once: true});
  else syncAllPurchaseSummaries();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uni-redesign-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const link = event.target.closest('a[data-uni-redesign-link]');
  const drawer = link?.closest('header-drawer');
  if (!drawer || !drawer.mainDetailsToggle?.open || typeof drawer.closeMenuDrawer !== 'function') return;
  const summary = drawer.mainDetailsToggle.querySelector('summary');
  drawer.closeMenuDrawer(event, summary);
  summary.setAttribute('aria-expanded', 'false');
});
  } catch(e) { console.error(e); }
})();

})();
